import type { i18n as I18nInstance, TFunction } from "i18next";

/**
 * The label a history row shows for a field: the entity's audit label when it has one, else its form label, else the
 * field's own name. Audit labels exist for fields the form shows converted (km, minutes) while history holds the
 * stored value (meters, seconds), so the form label's unit would be wrong there.
 */
export const translateEntityPropertyKey = ({
  entity,
  key,
  t,
  i18n,
}: {
  entity?: string;
  key: string;
  t: TFunction;
  i18n: I18nInstance;
}): string => {
  if (!entity) {
    return key;
  }

  const auditKey = `${entity}.auditLabel.${key}`;
  const translationKey = i18n.exists(auditKey)
    ? auditKey
    : `${entity}.formLabel.${key}`;
  if (!i18n.exists(translationKey)) {
    return key;
  }

  const translatedValue = t(translationKey, { returnObjects: true }) as unknown;
  return typeof translatedValue === "string" ? translatedValue : key;
};
